import { Action } from '@ngrx/store';

import { IRestaurant } from '@shared/shared/interfaces/restaurant.interface';

// Get data for a single restaurant
export const VIEW_RESTAURANT = '[Restaurant] View Restaurant';
export const VIEW_RESTAURANT_FAIL = '[Restaurant] View Restaurant Fail';
export const VIEW_RESTAURANT_SUCCESS = '[Restaurant] View Restaurant Success';
export const RESTAURANT_LOADED = '[Restaurant] Restaurant Loaded';

export class ViewRestaurant implements Action {
  readonly type = VIEW_RESTAURANT;
  constructor(public id: number) {}
}

export class ViewRestaurantFail implements Action {
  readonly type = VIEW_RESTAURANT_FAIL;
  constructor(public payload: any) {}
}

export class ViewRestaurantSuccess implements Action {
  readonly type = VIEW_RESTAURANT_SUCCESS;
  constructor(public payload: IRestaurant) {}
}

export class RestaurantLoaded implements Action {
  readonly type = RESTAURANT_LOADED;
  constructor(public restaurant: IRestaurant) {}
}

// clear restaurant
export const CLEAR_RESTAURANT = '[Restaurant] Clear Restaurant';

export class ClearRestaurant implements Action {
  readonly type = CLEAR_RESTAURANT;
}

export type RestaurantAction =
  | ViewRestaurant
  | ViewRestaurantFail
  | ViewRestaurantSuccess
  | RestaurantLoaded
  | ClearRestaurant;
